import { OutboundReferenceCollection } from '@gooduncles/gu-app-schema';
import { ICellRendererParams } from 'ag-grid-community';
import { sumBy } from 'lodash-es';
import { useEffect } from 'react';

import useSWRProductOutboundTxns from 'src/hooks/swr/useSWRProductOutboundTxnsForInventory';

interface AgCellDepletionDateOrderQtyProps extends ICellRendererParams {
  inventoryId: string;
  quantity: number;
}

const AgCellDepletionDateOrderQty = (params: AgCellDepletionDateOrderQtyProps) => {
  const { inventoryId, quantity } = params;
  const isInfinite = !isFinite(quantity);
  const { productOutboundTransactions } = useSWRProductOutboundTxns(isInfinite ? undefined : inventoryId);
  const orderOutboundTxns = productOutboundTransactions?.filter(
    (txn) => txn.referenceCollection === OutboundReferenceCollection.ORDER,
  );

  const outboundSum = sumBy(orderOutboundTxns, 'requestQuantity');
  const value = isInfinite ? 0 : orderOutboundTxns?.length === 0 ? 0 : outboundSum;

  useEffect(() => {
    if (params.setValue) {
      params.setValue(value);
    }
  }, [params, value]);

  if (isInfinite) return <span className='gray600'>-</span>;

  return orderOutboundTxns?.length === 0 ? <span className='gray600'>-</span> : <span>{outboundSum}</span>;
};

export default AgCellDepletionDateOrderQty;
